import { parseShopifyUpload } from "./parse.js";
import { groupOrders, bucketByStateAndMonth } from "./group.js";
import { buildStateWorkbook } from "./xlsx.js";
import type { GeneratedFile } from "./types.js";

function slug(s: string): string {
  return s.replace(/[^A-Za-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}

function filenameFor(state: string, months: { year: number; month: number; monthLabel: string }[]): string {
  if (months.length === 0) return `${slug(state)}.xlsx`;
  const first = months[0];
  const last = months[months.length - 1];
  if (first.year === last.year && first.month === last.month) {
    return `${slug(state)}_${first.monthLabel.replace(" ", "_")}.xlsx`;
  }
  return `${slug(state)}_${first.monthLabel.replace(" ", "_")}-${last.monthLabel.replace(" ", "_")}.xlsx`;
}

export async function generateReports(input: ArrayBuffer | Uint8Array): Promise<GeneratedFile[]> {
  const raw = parseShopifyUpload(input);
  const grouped = groupOrders(raw);
  const buckets = bucketByStateAndMonth(grouped);

  const out: GeneratedFile[] = [];
  for (const bucket of buckets) {
    const buf = await buildStateWorkbook(bucket);
    out.push({
      state: bucket.state,
      stateAbbrev: bucket.stateAbbrev,
      filename: filenameFor(bucket.state, bucket.months),
      buffer: buf,
      sizeBytes: buf.byteLength,
      orderCount: bucket.totalOrders,
    });
  }
  return out;
}
